import React from 'react';

const NoMatch = () => {
  return (
    <div>
      <h2 className="text-white text-center">Page Not Found</h2>
    </div>
  );
};

export default NoMatch;